/**
 * Cleo ERP SaaS — Layout dashboard client
 * Header avec logo + menu utilisateur, contenu centré.
 */
import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Layout, Typography, Button, Space, Dropdown } from 'antd';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';

const { Header, Content } = Layout;

function ClientLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Déconnexion',
      onClick: handleLogout,
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh', background: '#F8FAFC' }}>
      <Header style={{
        background: '#FFFFFF',
        borderBottom: '1px solid #E5E7EB',
        boxShadow: '0 1px 3px rgba(15,23,42,0.06)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 24px',
        height: 64,
      }}>
        <Typography.Title level={4} style={{
          margin: 0,
          color: '#0F172A',
          fontWeight: 700,
        }}>
          Cleo ERP
        </Typography.Title>

        <Dropdown menu={{ items: menuItems }} placement="bottomRight">
          <Space style={{ cursor: 'pointer' }}>
            <div style={{
              width: 32, height: 32, borderRadius: '50%',
              background: '#0F172A', color: '#FFFFFF',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 13, fontWeight: 600,
            }}>
              {user?.email?.[0]?.toUpperCase() || <UserOutlined />}
            </div>
            <Typography.Text style={{ color: '#64748B', fontSize: 13 }}>
              {user?.email}
            </Typography.Text>
          </Space>
        </Dropdown>
      </Header>

      <Content style={{ padding: 24, maxWidth: 960, margin: '0 auto', width: '100%' }}>
        <Outlet />
      </Content>
    </Layout>
  );
}

export default ClientLayout;
